// extracted by mini-css-extract-plugin
export var animationContainer = "_i2-0";
export var asteriskIcon = "_i2-8";
export var conversationLeftSection = "_i2-4";
export var conversationListItem = "_i2-3";
export var conversationMiddleSection = "_i2-5";
export var conversationRightSection = "_i2-6";
export var detailsContent = "_i2-1";
export var listContainer = "_i2-7";
export var modalContent = "_i2-2";